import { AppTabs } from 'shared/UI/UIKit/Tab';
import { AppLoader } from 'shared/UI/UIKit/Loader';
import { useCalendarTabsService } from '../model';
import { CalendarTable } from '../../Table';

interface CalendarTabsProps {
  selectedTab?: string;
  onSelectTab: (tab: string) => void;
}

export const CalendarTabs = ({ selectedTab, onSelectTab }: CalendarTabsProps) => {
  const {
    state: { tabs, loading },
  } = useCalendarTabsService({ onSelectTab });

  if (loading) {
    return <AppLoader />;
  }

  return (
    <AppTabs onChange={onSelectTab} defaultActiveKey={selectedTab} activeKey={selectedTab}>
      {tabs.map((tab) => (
        <AppTabs.TabPane key={tab.key} tab={tab.name}>
          <CalendarTable selectedTab={tab.key} key={tab.key} />
        </AppTabs.TabPane>
      ))}
    </AppTabs>
  );
};
